'use strict';

import $ from 'jquery';

const graphBoxesFy = function() {
    //legend、グラフのclass番号を指定
    //JSONの配列上から0、1、2・・・と続く

    //「利益率以外」のlegend class番号
    let OP_NO = '1', //営業利益
        RP_NO = '2', //経常利益
        NP_NO = '3', //当期利益
        SALES_NO = '0'; //売上高

    //「利益率」のlegend class番号
    let SL_OP_NO  = '0', //売上高営業利益率
        SL_RP_NO  = '1', //売上高経常利益率
        SL_NP_NO  = '2', //売上高当期利益率
        SL_ROE_NO = '3', //ROE
        SL_ROA_NO = '4'; //ROA

    /**
     * checkboxの同クラスの状態を変更する
     * @param {string} className クラス名 .op
     * @param {boolean} status checked状態 true/false
     */
    function changeInputChecked(className, status) {
        $('#all_graph_list .legend_list ' + className + ' input').each(function(idx, input) {
            $(input).prop('checked', status);
        });
    }

    //営業利益
    $('#all_graph_list .op input').on('click', function () {
        $('#all_graph_list #graph_fy_list .highcharts-legend-item.highcharts-series-' + OP_NO + ' span').trigger('click');
        $('#all_graph_list #graph_fy_prev_list .highcharts-legend-item.highcharts-series-' + OP_NO + ' span').trigger('click');
        $('#all_graph_list #graph_fy_idx_list .highcharts-legend-item.highcharts-series-' + OP_NO + ' span').trigger('click');
        $('#all_graph_list #graph_fy_sales_list .highcharts-legend-item.highcharts-series-' + SL_OP_NO + ' span').trigger('click');

        let legend = $('#all_graph_list .legend_list .op');
        if (legend.attr('class').indexOf('item_hide') !== -1) {
            legend.removeClass('item_hide');
            changeInputChecked('.op', true);
        } else {
            legend.addClass('item_hide');
            changeInputChecked('.op', false);
        }
    });

    //経常利益
    $('#all_graph_list .rp input').on('click', function () {
        $('#all_graph_list #graph_fy_list .highcharts-legend-item.highcharts-series-' + RP_NO + ' span').trigger('click');
        $('#all_graph_list #graph_fy_prev_list .highcharts-legend-item.highcharts-series-' + RP_NO + ' span').trigger('click');
        $('#all_graph_list #graph_fy_idx_list .highcharts-legend-item.highcharts-series-' + RP_NO + ' span').trigger('click');
        $('#all_graph_list #graph_fy_sales_list .highcharts-legend-item.highcharts-series-' + SL_RP_NO + ' span').trigger('click');

        let legend = $('#all_graph_list .legend_list .rp');
        if (legend.attr('class').indexOf('item_hide') !== -1) {
            legend.removeClass('item_hide');
            changeInputChecked('.rp', true);
        } else {
            legend.addClass('item_hide');
            changeInputChecked('.rp', false);
        }
    });

    //当期利益
    $('#all_graph_list .np input').on('click', function () {
        $('#all_graph_list #graph_fy_list .highcharts-legend-item.highcharts-series-' + NP_NO + ' span').trigger('click');
        $('#all_graph_list #graph_fy_prev_list .highcharts-legend-item.highcharts-series-' + NP_NO + ' span').trigger('click');
        $('#all_graph_list #graph_fy_idx_list .highcharts-legend-item.highcharts-series-' + NP_NO + ' span').trigger('click');
        $('#all_graph_list #graph_fy_sales_list .highcharts-legend-item.highcharts-series-' + SL_NP_NO + ' span').trigger('click');

        let legend = $('#all_graph_list .legend_list .np');
        if (legend.attr('class').indexOf('item_hide') !== -1) {
            legend.removeClass('item_hide');
            changeInputChecked('.np', true);
        } else {
            legend.addClass('item_hide');
            changeInputChecked('.np', false);
        }
    });

    //売上高
    //業績、前期比、指数の時のみ実行
    $('#all_graph_list .sales input').on('click', function () {
        $('#all_graph_list #graph_fy_list .highcharts-legend-item.highcharts-series-' + SALES_NO + ' span').trigger('click');
        $('#all_graph_list #graph_fy_prev_list .highcharts-legend-item.highcharts-series-' + SALES_NO + ' span').trigger('click');
        $('#all_graph_list #graph_fy_idx_list .highcharts-legend-item.highcharts-series-' + SALES_NO + ' span').trigger('click');

        let legend = $('#all_graph_list .legend_list .sales');
        if (legend.attr('class').indexOf('item_hide') !== -1) {
            legend.removeClass('item_hide');
            changeInputChecked('.sales', true);
        } else {
            legend.addClass('item_hide');
            changeInputChecked('.sales', false);
        }
    });

    //ROE
    $('#all_graph_list .roe input').on('click', function () {
        $('#all_graph_list #graph_fy_sales_list .highcharts-legend-item.highcharts-series-' + SL_ROE_NO + ' span').trigger('click');

        let legend = $('#all_graph_list .legend_list .roe');
        if (legend.attr('class').indexOf('item_hide') !== -1) {
            legend.removeClass('item_hide');
            changeInputChecked('.roe', true);
        } else {
            legend.addClass('item_hide');
            changeInputChecked('.roe', false);
        }
    });

    //ROA
    $('#all_graph_list .roa input').on('click', function () {
        $('#all_graph_list #graph_fy_sales_list .highcharts-legend-item.highcharts-series-' + SL_ROA_NO + ' span').trigger('click');

        let legend = $('#all_graph_list .legend_list .roa');
        if (legend.attr('class').indexOf('item_hide') !== -1) {
            legend.removeClass('item_hide');
            changeInputChecked('.roa', true);
        } else {
            legend.addClass('item_hide');
            changeInputChecked('.roa', false);
        }
    });
};

export { graphBoxesFy };
